// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35Ks_","toggle":"styles_toggle__1Uw-P","preview":"styles_preview__2dVah"};